import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  HostBinding
} from '@angular/core';

@Component({
  selector: '[sc-spinner], sc-spinner',
  template: `
    <ng-content></ng-content>
  `,
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpinnerComponent {
  @HostBinding('class.center-pos') @Input() centerPos = false;
}
